import React, { useEffect } from 'react'
import ArticlesDisplay from '../components/ArticlesDisplay'
import ArticleVolume from '../components/ArticleVolume'
import Menu from '../components/Menu'
import './styles.css'

const Articles = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
  return (
    <div>
      <div className="home-section-one">
        <ArticleVolume  />
      </div>
      <div className="home-section-two">
        <Menu />
      </div>
      <div className="home-section-three">
        <ArticlesDisplay />
      </div>
    </div>
  )
}

export default Articles